// «Avisame cuando llegue» (snippets/notify-form.liquid, ADR 0016): el {% form 'customer' %} viaja en un <template> y se clona
// recién al abrir el details. Así ningún formulario de cliente está en el HTML inicial y el hCaptcha de Shopify (≈ 1 MB)
// no se descarga hasta que alguien lo va a usar. Después de enviar (éxito o error) se clona de entrada y se abre.
// Las calculadoras cambian los tags en data-tags (el input todavía puede no existir).
class NotifyForm extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.details = this.querySelector('details');
    this.template = this.querySelector('template[data-notify-template]');
    if (!this.details || !this.template) return;
    const posted = this.template.content.querySelector('.notify__success, .notify__errors');
    if (posted) { this.mount(); this.details.open = true; }
    this.details.addEventListener('toggle', () => { if (this.details.open) this.mount(); });
  }

  mount() {
    if (this.mounted) return this.form;
    this.mounted = true;
    const panel = this.querySelector('.notify__panel');
    panel.append(this.template.content.cloneNode(true));
    this.form = panel.querySelector('form');
    this.setTags(this.dataset.tags);
    return this.form;
  }

  setTags(value) {
    if (!value) return;
    this.dataset.tags = value;
    const input = this.querySelector('[data-notify-tags]');
    if (input) input.value = value;
  }
}

if (!customElements.get('notify-form')) customElements.define('notify-form', NotifyForm);
